import React, { useEffect, useState } from 'react';
import { Box, Button, Flex, Heading, Text } from 'rebass';
import { getRegionByAbbreviation, RegionSelectNotForm } from '../components/RegionSelect';
import { sleep } from '../utils/sleep';
import PayersDropDown from '../components/bridge/PayersDropDown';
import { Mutation, withApollo } from 'react-apollo';
import { GET_REGION_ELIGIBILITY } from '../graphql';
import { AnimateHit, BridgeEligible, BridgeIneligible, RUN_BRIDGE_SOFT_ELIGIBILITY } from '../components/bridge/softEligibilityForm';
import { Link } from 'react-router-dom';
import TextInput from '../components/TextInput';
import * as Yup from 'yup';
import Mailcheck from 'react-mailcheck';
import { Form, Formik } from 'formik';
import FormField from '../components/FormField';
import styled from 'styled-components';
import gql from 'graphql-tag';
import withAnalytics from '../lib/withAnalytics';
import { removeRetellWidget } from '../utils/retellWidget';

const MailcheckWrapper = styled.div`
  text-align: right;
  @media screen and (max-width: 52em) {
    text-align: left;
  }
`;

const MailcheckButton = styled(Button)`
  padding: 0;
  border: none;
  background: none;
  font-size: inherit;
  font-style: italic;
  color: rgb(237, 183, 168);
  cursor: pointer;
  text-decoration: underline;
  text-underline-position: under;

  &:focus {
    outline: none;
    color: rgb(237, 183, 168);
  }

  &:hover {
    color: rgb(237, 183, 168);
  }

  &:active {
    color: rgb(237, 183, 168);
  }
`;
const SEND_KLAVIYO = gql`
  mutation sendKlaviyoResultsEmbedInsuranceCheck($state: String, $planType: String, $insurance: String, $email: String, $coverage: String) {
    sendKlaviyoResultsEmbedInsuranceCheck(state: $state, planType: $planType, insurance: $insurance, email: $email, coverage: $coverage) {
      ok
    }
  }
`;
const schema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
});
const BridgeSoftEligibilityWithProps = ({ client, analytics }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [department, setDepartment] = useState();
  const [currentState, setCurrentState] = useState('STATE');
  const [finalState, setFinalState] = useState('STATE');
  const [patientState, setPatientState] = useState(null);
  const [selectedPayer, setSelectedPayer] = useState();
  const [klaviyoResult, setKlaviyoResult] = useState({});

  useEffect(
    () => {
      if (patientState) {
        checkStateEligibility();
      }
    },
    [patientState]
  );

  const checkStateEligibility = async () => {
    if (!patientState) return;

    setIsLoading(true);

    try {
      const stateEligibility = await client.query({
        query: GET_REGION_ELIGIBILITY,
        variables: {
          state: patientState,
        },
      });

      setIsLoading(false);

      if (
        !stateEligibility ||
        !stateEligibility.data ||
        !stateEligibility.data.getRegionEligibility ||
        (stateEligibility.data.getRegionEligibility !== 'full' && stateEligibility.data.getRegionEligibility !== 'visit')
      ) {
        setCurrentState('NO_SERVICE');
      } else {
        setCurrentState('INSURANCE_TYPE');
      }
    } catch (error) {
      setIsLoading(false);
      console.log('ELIGIBI err', error);
    }
  };

  useEffect(() => {
    const rem = async () => {
      await sleep(500);
      removeRetellWidget();

      // if (window.Beacon) {
      //   window.Beacon('on', 'ready', () => window.Beacon('destroy'));
      // } else {
      //   await sleep(3000);
      //   if (window.Beacon) {
      //     window.Beacon('on', 'ready', () => window.Beacon('destroy'));
      //   }
      // }

      await sleep(1500);

      try {
        removeRetellWidget();
        // window.Beacon('destroy');
      } catch (error) {}
    };

    if (window.Beacon) {
      window.Beacon('on', 'ready', () => window.Beacon('destroy'));
      try {
        window.Beacon('destroy');
      } catch (error) {}
    }

    rem();
    document.body.style.backgroundColor = 'transparent';

    return () => {
      document.body.style.backgroundColor = '';
    };
  }, []);

  useEffect(
    () => {
      if (finalState === 'INELIGIBLE') {
        setKlaviyoResult({
          ...klaviyoResult,
          coverage: 'Other',
        });
      }
    },
    [finalState]
  );

  if (currentState === 'STATE') {
    return (
      <Flex mb={4} flexDirection="column" justifyContent={'center'} alignItems={'center'} p={3}>
        <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column">
          <Heading textAlign="center" mb={4}>
            In which state are you located?
          </Heading>
          <div
            style={{
              maxWidth: '500px',
              alignSelf: 'center',
              width: '100%',
            }}
          >
            <RegionSelectNotForm
              value={department}
              style={{ width: '100%' }}
              onSelectionChange={(val) => {
                setDepartment(val);
              }}
            />
          </div>
          <Button
            onClick={() => {
              setPatientState(department);
              setKlaviyoResult({
                ...klaviyoResult,
                state: department,
              });
            }}
            mt={4}
            variant={'primary'}
            disabled={!department || !!isLoading}
          >
            {!!isLoading ? 'Checking state...' : 'Continue'}
          </Button>
        </Flex>
      </Flex>
    );
  }

  if (currentState === 'INSURANCE_TYPE') {
    return (
      <Flex mb={4} flexDirection="column" justifyContent={'center'} alignItems={'center'} p={3}>
        <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column" style={{ maxWidth: '500px' }}>
          <Heading textAlign="center" mb={4}>
            What type of insurance do you have?
          </Heading>
          <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column" style={{ maxWidth: '300px' }}>
            <Button
              onClick={() => {
                setFinalState('INELIGIBLE');
                setKlaviyoResult({
                  ...klaviyoResult,
                  // planType: 'Medicare',
                });
                setCurrentState('EMAIL');
                // setCurrentState('INSURANCE_MEDICARE');
              }}
              variant={'outline'}
            >
              <Flex alignItems={'center'}>
                <Box style={{ height: '12px', width: '12px', borderRadius: '12px', border: '1px solid #344f79' }} mr={3} />
                <Text>Medicare / Medicaid / Tricare</Text>
              </Flex>
            </Button>
            <Button
              onClick={() => {
                setFinalState('INELIGIBLE');
                setKlaviyoResult({
                  ...klaviyoResult,
                  // planType: 'HMO',
                });
                setCurrentState('EMAIL');
              }}
              mt={2}
              variant={'outline'}
            >
              <Flex alignItems={'center'}>
                <Box style={{ height: '12px', width: '12px', borderRadius: '12px', border: '1px solid #344f79' }} mr={3} />
                <Text>HMO</Text>
              </Flex>
            </Button>
            <Button
              onClick={() => {
                setKlaviyoResult({
                  ...klaviyoResult,
                  // planType: 'PPO',
                });
                setCurrentState('PICK_INSURANCE');
              }}
              mt={2}
              variant={'outline'}
            >
              <Flex alignItems={'center'}>
                <Box style={{ height: '12px', width: '12px', borderRadius: '12px', border: '1px solid #344f79' }} mr={3} />
                <Text>PPO</Text>
              </Flex>
            </Button>
            <Button
              onClick={() => {
                setFinalState('I_DONT_KNOW');
                setKlaviyoResult({
                  ...klaviyoResult,
                  // planType: `I don't know`,
                });
                setCurrentState('EMAIL');
              }}
              mt={2}
              variant={'outline'}
            >
              <Flex alignItems={'center'}>
                <Box style={{ height: '12px', width: '12px', borderRadius: '12px', border: '1px solid #344f79' }} mr={3} />
                <Text>I don't know</Text>
              </Flex>
            </Button>
          </Flex>
        </Flex>
      </Flex>
    );
  }

  if (currentState === 'INSURANCE_MEDICARE') {
    return (
      <Flex mb={4} flexDirection="column" justifyContent={'center'} alignItems={'center'} p={3}>
        <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column" style={{ maxWidth: '500px' }}>
          <Heading textAlign="center" mb={3}>
            Do you have a medicare advantage plan?
          </Heading>
          <Text textAlign={'center'}>(Your card will usually show a private insurer like Aetna, Humana, UnitedHealthcare...)</Text>
          <Flex flexDirection={'column'} style={{ maxWidth: '300px' }}>
            <Button
              onClick={() => {
                setCurrentState('PICK_INSURANCE');
              }}
              mt={4}
              variant={'outline'}
            >
              <Flex alignItems={'center'}>
                <Box style={{ height: '12px', width: '12px', borderRadius: '12px', border: '1px solid #344f79' }} mr={3} />
                <Text>Yes</Text>
              </Flex>
            </Button>
            <Button
              onClick={() => {
                setCurrentState('INELIGIBLE');
              }}
              mt={2}
              variant={'outline'}
            >
              <Flex alignItems={'center'}>
                <Box style={{ height: '12px', width: '12px', borderRadius: '12px', border: '1px solid #344f79' }} mr={3} />
                <Text>NO</Text>
              </Flex>
            </Button>
          </Flex>
        </Flex>
      </Flex>
    );
  }
  if (currentState === 'PICK_INSURANCE') {
    return (
      <Mutation
        mutation={RUN_BRIDGE_SOFT_ELIGIBILITY}
        onCompleted={(e) => {
          setFinalState(e.runBridgeSoftEligibility.status);
          setCurrentState('EMAIL');
          // setCurrentState(e.runBridgeSoftEligibility.status);
        }}
      >
        {(runSoftEligibility, { loading: loadingSoft, error: errorSoft, data: dataSoft }) => {
          return (
            <Flex mb={4} flexDirection="column" justifyContent={'center'} alignItems={'center'} p={3}>
              <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column" style={{ maxWidth: '500px' }}>
                <Heading textAlign="center" mb={4}>
                  Pick Your Insurance Provider
                </Heading>
                <Text textAlign="center" mb={4} fontSize="18px">
                  What insurance do you plan on using?
                </Text>
              </Flex>
              <div style={{ maxWidth: '500px', alignSelf: 'center', width: '100%' }}>
                <PayersDropDown
                  selectedPayer={selectedPayer}
                  onPayerChange={(pyr) => {
                    setSelectedPayer(pyr);
                  }}
                />
              </div>
              <Text textAlign="left" mb={4} fontSize="14px" fontWeight={200} color="#7c7c7c" style={{ maxWidth: '500px', alignSelf: 'center', width: '100%' }}>
                e.g. Aetna, United Healthcare
              </Text>
              <Button
                variant="pink"
                width={'fit-content'}
                type="submit"
                disabled={!selectedPayer || !!loadingSoft}
                onClick={() => {
                  setKlaviyoResult({
                    ...klaviyoResult,
                    coverage: selectedPayer.label,
                  });
                  if (selectedPayer.label === 'Cigna') {
                    if (patientState === 'AZ' || patientState === 'CA' || patientState === 'CO' || patientState === 'FL' || patientState === 'TX' || patientState === 'WA') {
                      setCurrentState('ELIGIBLE');
                    } else {
                      setCurrentState('INELIGIBLE');
                    }
                    return;
                  }

                  runSoftEligibility({
                    variables: {
                      state: patientState,
                      payerId: selectedPayer.bridgeId,
                    },
                  });
                }}
              >
                {!!loadingSoft ? 'Checking...' : 'Check'}
              </Button>
            </Flex>
          );
        }}
      </Mutation>
    );
  } else if (currentState === 'ELIGIBLE') {
    return (
      <Flex flexDirection={'column'} alignItems={'center'} justifyContent={'center'} p={3} style={{ maxWidth: '500px', margin: '0 auto' }}>
        <BridgeEligible
          onLoaded={async () => {
            await sleep(350);
            client.mutate({
              mutation: SEND_KLAVIYO,
              variables: {
                ...klaviyoResult,
                coverage: klaviyoResult.coverage !== 'Other' ? 'Bridge' : 'Other',
              },
            });
            analytics.track('soft eligibility', { coverage: klaviyoResult.coverage !== 'Other' ? 'Bridge' : 'Other' });
            // console.log({ eligibleLoaded: klaviyoResult });
          }}
        />
        <Link style={{ marginTop: '24px' }} to={`/registration`} target="_top">
          <Button variant={'primary'}>Continue</Button>
        </Link>
        {/* <Link style={{ marginTop: '24px' }} to={`/prequalification`} target="_top">
          <Button variant={'primary'}>Schedule</Button>
        </Link> */}
      </Flex>
    );
  } else if (currentState === 'INELIGIBLE') {
    return (
      <Flex flexDirection={'column'} alignItems={'center'} justifyContent={'center'} p={3} style={{ maxWidth: '500px', margin: '0 auto' }}>
        <BridgeIneligible state={getRegionByAbbreviation(patientState).label} />
        <Link style={{ marginTop: '24px' }} to={`/registration`} target="_top">
          <Button variant={'primary'}>Continue</Button>
        </Link>
        {/* <Link style={{ marginTop: '24px' }} to={`/book-appointment-legacy/${getRegionByAbbreviation(patientState).label}`} target="_top">
          <Button variant={'primary'}>Continue</Button>
        </Link> */}
      </Flex>
    );
  } else if (currentState === 'NO_SERVICE') {
    return (
      <Flex alignItems={'center'} justifyContent={'center'} p={3}>
        <Flex flexDirection={'column'} style={{ maxWidth: '500px' }}>
          <AnimateHit style={{ alignSelf: 'center' }} className="animable">
            <svg width="120" height="120" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.92 55.9999H52.08C56.1867 55.9999 58.7467 51.5466 56.6933 47.9999L36.6133 13.3066C34.56 9.75994 29.44 9.75994 27.3867 13.3066L7.30666 47.9999C5.25333 51.5466 7.81333 55.9999 11.92 55.9999ZM32 37.3333C30.5333 37.3333 29.3333 36.1333 29.3333 34.6666V29.3333C29.3333 27.8666 30.5333 26.6666 32 26.6666C33.4667 26.6666 34.6667 27.8666 34.6667 29.3333V34.6666C34.6667 36.1333 33.4667 37.3333 32 37.3333ZM34.6667 47.9999H29.3333V42.6666H34.6667V47.9999Z"
                fill="rgb(255, 148, 17)"
              />
            </svg>
          </AnimateHit>

          <Text mt={3} textAlign={'center'} fontWeight={300}>
            Sorry
          </Text>

          <Text mt={3} textAlign={'center'} fontWeight={500}>
            Unfortunately Paloma doctors do not service {patientState ? getRegionByAbbreviation(patientState).label : 'your state'} currently. But we have some other Thyroid products for you!
          </Text>

          <Text mt={3} textAlign={'center'} fontWeight={300}>
            Including a complete at-home thyroid test test kits that includes Free T3 and Reverse T3
          </Text>

          <Link style={{ marginTop: '24px', alignSelf: 'center' }} to={`/purchase-kit`} target="_top">
            <Button variant={'primary'}>Test my thyroid</Button>
          </Link>
        </Flex>
      </Flex>
    );
  } else if (currentState === 'I_DONT_KNOW') {
    return (
      <Flex alignItems={'center'} justifyContent={'center'} p={3}>
        <Flex flexDirection={'column'} style={{ maxWidth: '500px' }}>
          <Text mt={3} textAlign={'center'} fontWeight={500}>
            Email us your insurance card at <a href="mailto:insurance@palomahealth.com">insurance@palomahealth.com</a>, and our support team will get back to you promptly to confirm if your insurance
            is accepted.
          </Text>

          <a
            style={{ marginTop: '24px', alignSelf: 'center' }}
            href={`mailto:insurance@palomahealth.com?subject=${encodeURIComponent(`Here is my insurance in ${getRegionByAbbreviation(patientState).label}`)}`}
            target="_top"
          >
            <Button variant={'primary'}>Continue</Button>
          </a>
        </Flex>
      </Flex>
    );
  } else if (currentState === 'EMAIL') {
    return (
      <Flex alignItems={'center'} justifyContent={'center'} p={3}>
        <Flex flexDirection={'column'} style={{ maxWidth: '500px', width: '100%' }}>
          <Text mt={3} mb={3} textAlign={'center'} fontWeight={500}>
            What is your email address?
          </Text>

          <Formik
            isInitialValid={false}
            validationSchema={schema}
            onSubmit={(values) => {
              setKlaviyoResult({
                ...klaviyoResult,
                email: values.email,
              });
              if (finalState !== 'ELIGIBLE') {
                client.mutate({
                  mutation: SEND_KLAVIYO,
                  variables: {
                    ...klaviyoResult,
                    coverage: klaviyoResult.coverage !== 'Other' ? 'Bridge' : 'Other',
                    email: values.email,
                  },
                });
                analytics.track('soft eligibility', { coverage: klaviyoResult.coverage !== 'Other' ? 'Bridge' : 'Other' });
                // console.log({
                //   noteligibleLoaded: {
                //     ...klaviyoResult,
                //     email: values.email,
                //   },
                // });
              }
              // console.log({ klaviyoResult });
              setCurrentState(finalState);
              // console.log(values);
              // props.onSubmit('giveToFriend', values, props.wizard);
            }}
            render={({ isValid, errors, touched, values, setFieldValue }) => (
              <Form>
                <Flex flexDirection={'column'}>
                  <FormField mb={3} error={touched.email && errors.email}>
                    <Mailcheck email={values.email}>
                      {(suggestion) => (
                        <>
                          <TextInput placeholder="Your Email Address" type="email" name="email" />
                          {suggestion && (
                            <MailcheckWrapper className="mailcheck">
                              Did you mean{' '}
                              <MailcheckButton type="button" onClick={() => setFieldValue('email', suggestion.full)}>
                                {suggestion.full}
                              </MailcheckButton>
                              ?
                            </MailcheckWrapper>
                          )}
                        </>
                      )}
                    </Mailcheck>
                  </FormField>
                  <Flex justifyContent="center" flexDirection="column" alignItems="center">
                    <Button disabled={!isValid} variant="primary" type="submit">
                      Continue
                    </Button>
                  </Flex>
                </Flex>
              </Form>
            )}
          />
          {/* </a> */}
        </Flex>
      </Flex>
    );
  }

  return <div />;
};

export const BridgeSoftEligibility = withApollo(withAnalytics(BridgeSoftEligibilityWithProps));
